/* Lichcards - designlaag, gedragsdeel (stijlaudit 2026-08-16)
   Puur cosmetisch: leest wat er al op de pagina staat en zet er iets netters neer.
   Uitzetten = {% render 'lichcards-design' %} uit layout/theme.liquid halen. */
(function () {
  'use strict';

  var LC_SCRIPT = document.currentScript;
  var LC_SHIPPING_LABEL = LC_SCRIPT && LC_SCRIPT.dataset.shippingLabel;
  var BODY = document.body;
  if (!BODY) return;
  BODY.classList.add('lc-design');

  

  /* Menu-items die uit het hoofdmenu mogen omdat ze al in de utility-balk
     rechtsboven staan. Alleen verbergen — in de Shopify-navigatie blijft
     alles gewoon staan, dus het live thema verandert hier niet van. */
  var MENU_VERBERGEN = [
    'kaarten verkopen', 'sell your cards', 'karten verkaufen',
    'vendre vos cartes', 'vende tus cartas', 'vendi le tue carte'
  ];

  var LC_LANG = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  if (!/^(nl|en|de|fr|es|it)$/.test(LC_LANG)) LC_LANG = 'nl';

  var LC_I18N = {
    nl: {
      shopCity: 'Winkel in Enkhuizen', freeShipping: 'Gratis verzending vanaf €75',
      sellCards: 'Verkoop je kaarten', loyalty: 'Spaarpunten', contact: 'Contact',
      searchLabel: 'Zoeken', searchPlaceholder: 'Zoek op kaart, set of product…', searchButton: 'Zoeken',
      refine: 'Verfijn je keuze', home: 'Home', breadcrumb: 'Kruimelpad', bestSellers: 'Meest gekocht',
      shortAdd: 'Toevoegen', shortOptions: 'Opties', boardGames: 'Bordspellen', accessories: 'Accessoires',
      japanese: 'Japans', english: 'Engels', german: 'Duits', french: 'Frans',
      italian: 'Italiaans', spanish: 'Spaans', korean: 'Koreaans', chinese: 'Chinees',
      panelAll: 'Alles in {x}'
    },
    en: {
      shopCity: 'Shop in Enkhuizen', freeShipping: 'Free shipping from €75',
      sellCards: 'Sell your cards', loyalty: 'Loyalty points', contact: 'Contact',
      searchLabel: 'Search', searchPlaceholder: 'Search by card, set or product…', searchButton: 'Search',
      refine: 'Refine your choice', home: 'Home', breadcrumb: 'Breadcrumb', bestSellers: 'Best sellers',
      shortAdd: 'Add', shortOptions: 'Options', boardGames: 'Board games', accessories: 'Accessories',
      japanese: 'Japanese', english: 'English', german: 'German', french: 'French',
      italian: 'Italian', spanish: 'Spanish', korean: 'Korean', chinese: 'Chinese',
      panelAll: 'View all {x}'
    },
    de: {
      shopCity: 'Shop in Enkhuizen', freeShipping: 'Kostenloser Versand ab 75 €',
      sellCards: 'Karten verkaufen', loyalty: 'Treuepunkte', contact: 'Kontakt',
      searchLabel: 'Suche', searchPlaceholder: 'Nach Karte, Set oder Produkt suchen…', searchButton: 'Suchen',
      refine: 'Auswahl verfeinern', home: 'Startseite', breadcrumb: 'Brotkrümelnavigation', bestSellers: 'Meistverkauft',
      shortAdd: 'Hinzufügen', shortOptions: 'Optionen', boardGames: 'Brettspiele', accessories: 'Zubehör',
      japanese: 'Japanisch', english: 'Englisch', german: 'Deutsch', french: 'Französisch',
      italian: 'Italienisch', spanish: 'Spanisch', korean: 'Koreanisch', chinese: 'Chinesisch',
      panelAll: 'Alles im Bereich {x}'
    },
    fr: {
      shopCity: 'Boutique à Enkhuizen', freeShipping: 'Livraison offerte dès 75 €',
      sellCards: 'Vendre vos cartes', loyalty: 'Points de fidélité', contact: 'Contact',
      searchLabel: 'Recherche', searchPlaceholder: 'Rechercher une carte, une extension ou un produit…', searchButton: 'Rechercher',
      refine: 'Affinez votre choix', home: 'Accueil', breadcrumb: 'Fil d’Ariane', bestSellers: 'Meilleures ventes',
      shortAdd: 'Ajouter', shortOptions: 'Options', boardGames: 'Jeux de société', accessories: 'Accessoires',
      japanese: 'Japonais', english: 'Anglais', german: 'Allemand', french: 'Français',
      italian: 'Italien', spanish: 'Espagnol', korean: 'Coréen', chinese: 'Chinois',
      panelAll: 'Tout l’univers {x}'
    },
    es: {
      shopCity: 'Tienda en Enkhuizen', freeShipping: 'Envío gratis desde 75 €',
      sellCards: 'Vende tus cartas', loyalty: 'Puntos de fidelidad', contact: 'Contacto',
      searchLabel: 'Buscar', searchPlaceholder: 'Busca una carta, un set o un producto…', searchButton: 'Buscar',
      refine: 'Afina tu búsqueda', home: 'Inicio', breadcrumb: 'Migas de pan', bestSellers: 'Más vendidos',
      shortAdd: 'Añadir', shortOptions: 'Opciones', boardGames: 'Juegos de mesa', accessories: 'Accesorios',
      japanese: 'Japonés', english: 'Inglés', german: 'Alemán', french: 'Francés',
      italian: 'Italiano', spanish: 'Español', korean: 'Coreano', chinese: 'Chino',
      panelAll: 'Ver todo en {x}'
    },
    it: {
      shopCity: 'Negozio a Enkhuizen', freeShipping: 'Spedizione gratuita da 75 €',
      sellCards: 'Vendi le tue carte', loyalty: 'Punti fedeltà', contact: 'Contatti',
      searchLabel: 'Cerca', searchPlaceholder: 'Cerca una carta, un set o un prodotto…', searchButton: 'Cerca',
      refine: 'Affina la scelta', home: 'Home', breadcrumb: 'Percorso di navigazione', bestSellers: 'Più venduti',
      shortAdd: 'Aggiungi', shortOptions: 'Opzioni', boardGames: 'Giochi da tavolo', accessories: 'Accessori',
      japanese: 'Giapponese', english: 'Inglese', german: 'Tedesco', french: 'Francese',
      italian: 'Italiano', spanish: 'Spagnolo', korean: 'Coreano', chinese: 'Cinese',
      panelAll: 'Vedi tutto in {x}'
    }
  };

  function tr(key) {
    return (LC_I18N[LC_LANG] && LC_I18N[LC_LANG][key]) || LC_I18N.nl[key] || key;
  }

  var LC_ROOT = LC_LANG === 'nl' ? '' : '/' + LC_LANG;
  function lcPath(path) {
    if (!path || path.charAt(0) !== '/' || /^\/(?:en|de|fr|es|it)(?:\/|$)/.test(path)) return path;
    return (LC_ROOT + path).replace(/\/{2,}/g, '/');
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function findWithin(scope, selector) {
    var root = scope || document;
    var matches = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.nodeType === 1 && root.matches(selector)) matches.unshift(root);
    return matches;
  }

  var S = 'fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
  var ICONS = {
    pokemon:   '<circle cx="12" cy="12" r="9" ' + S + '/><path d="M3 12h6m6 0h6" ' + S + '/><circle cx="12" cy="12" r="2.6" ' + S + '/>',
    magic:     '<path d="M12 3c2.6 3.4 5 6.2 5 9a5 5 0 0 1-10 0c0-2.8 2.4-5.6 5-9Z" ' + S + '/>',
    onepiece:  '<path d="M6.5 15c0-4 2.4-7 5.5-7s5.5 3 5.5 7" ' + S + '/><path d="M3 15.5h18" ' + S + '/><path d="M8.5 12h7" ' + S + '/>',
    yugioh:    '<path d="M12 3.5 21 19H3l9-15.5Z" ' + S + '/><circle cx="12" cy="14" r="2.2" ' + S + '/>',
    lorcana:   '<path d="M12 3.5 20 8v8l-8 4.5L4 16V8l8-4.5Z" ' + S + '/><path d="M12 9.5v6" ' + S + '/>',
    dragonball:'<circle cx="12" cy="12" r="8.5" ' + S + '/><path d="m12 8 1.4 2.9 3.1.4-2.3 2.2.6 3.1-2.8-1.5-2.8 1.5.6-3.1-2.3-2.2 3.1-.4L12 8Z" ' + S + '/>',
    digimon:   '<rect x="5" y="5" width="14" height="14" rx="2.5" ' + S + '/><rect x="9" y="9" width="6" height="6" rx="1" ' + S + '/><path d="M9 3v2m6-2v2M9 19v2m6-2v2M3 9h2m-2 6h2m14-6h2m-2 6h2" ' + S + '/>',
    starwars:  '<path d="M12 2.5v19M2.5 12h19M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4" ' + S + '/>',
    riftbound: '<path d="M13.5 2.5 6 13h5l-2.5 8.5L18 10h-5l.5-7.5Z" ' + S + '/>',
    gundam:    '<path d="M4 8.5 12 4l8 4.5v5L12 20l-8-6.5v-5Z" ' + S + '/><path d="M8 11h8" ' + S + '/>',
    fab:       '<path d="M4.5 4.5 15 15m4.5 4.5L17 17M19.5 4.5 9 15m-4.5 4.5L7 17" ' + S + '/>',
    weiss:     '<rect x="3.5" y="4.5" width="8" height="15" rx="1.5" ' + S + '/><rect x="12.5" y="4.5" width="8" height="15" rx="1.5" ' + S + '/>',
    sports:    '<rect x="4" y="3.5" width="16" height="17" rx="2" ' + S + '/><path d="m12 8 1.3 2.7 2.9.4-2.1 2 .5 2.9-2.6-1.4-2.6 1.4.5-2.9-2.1-2 2.9-.4L12 8Z" ' + S + '/>',
    minecraft: '<rect x="4" y="4" width="16" height="16" rx="1.5" ' + S + '/><path d="M4 12h16M12 4v16" ' + S + '/>',
    adrenalyn: '<rect x="4" y="3.5" width="16" height="17" rx="2" ' + S + '/><path d="m13.5 7-4.5 6.5h3l-1 4L15.5 11h-3l1-4Z" ' + S + '/>',
    altered:   '<path d="M4 7.5 12 4l8 3.5-8 3.5-8-3.5Z" ' + S + '/><path d="M4 13.5 12 10l8 3.5-8 3.5-8-3.5Z" ' + S + '/><path d="M8 18.5l4 1.5 4-1.5" ' + S + '/>',
    hololive:  '<rect x="9" y="3" width="6" height="10" rx="3" ' + S + '/><path d="M5.5 11a6.5 6.5 0 0 0 13 0" ' + S + '/><path d="M12 17.5v3M8.5 20.5h7" ' + S + '/>',
    finalfantasy: '<path d="M12 2.5 18 9l-6 12.5L6 9l6-6.5Z" ' + S + '/><path d="M6 9h12" ' + S + '/>',
    singles:   '<rect x="3" y="6" width="11" height="14" rx="1.8" transform="rotate(-8 8.5 13)" ' + S + '/><rect x="10" y="4" width="11" height="14" rx="1.8" transform="rotate(8 15.5 11)" ' + S + '/>',
    sealed:    '<path d="M3.5 7.5 12 3.5l8.5 4v9L12 20.5l-8.5-4v-9Z" ' + S + '/><path d="M3.5 7.5 12 11.5l8.5-4M12 11.5v9" ' + S + '/>',
    board:     '<rect x="3.5" y="3.5" width="17" height="17" rx="3" ' + S + '/><circle cx="8.5" cy="8.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="15.5" cy="8.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none"/><circle cx="8.5" cy="15.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="15.5" cy="15.5" r="1.1" fill="currentColor" stroke="none"/>',
    acc:       '<path d="M5 4.5h14v15H5z" ' + S + '/><path d="M8.5 4.5v6l3.5-2 3.5 2v-6" ' + S + '/>',
    buy:       '<path d="M12 3.5v11m0 0 4-4m-4 4-4-4" ' + S + '/><path d="M4.5 16v3.5h15V16" ' + S + '/>',
    store:     '<path d="M4 10v9.5h16V10" ' + S + '/><path d="M3 10 5 4.5h14L21 10a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0Z" ' + S + '/>',
    star:      '<path d="m12 3.5 2.6 5.4 5.9.8-4.3 4.1 1.1 5.9L12 16.9l-5.3 2.8 1.1-5.9L3.5 9.7l5.9-.8L12 3.5Z" ' + S + '/>',
    phone:     '<path d="M6 3.5h4l1.5 4-2 1.5a11 11 0 0 0 5.5 5.5l1.5-2 4 1.5v4a2 2 0 0 1-2 2C10.5 20 4 13.5 4 5.5a2 2 0 0 1 2-2Z" ' + S + '/>',
    truck:     '<path d="M2.5 6.5h11v9h-11z" ' + S + '/><path d="M13.5 9.5H17l3 3v3h-6.5" ' + S + '/><circle cx="6.5" cy="17.5" r="1.8" ' + S + '/><circle cx="16.5" cy="17.5" r="1.8" ' + S + '/>',
    zoek:      '<circle cx="11" cy="11" r="6.5" ' + S + '/><path d="m16 16 4.5 4.5" ' + S + '/>'
  };

  /* Officiële spellogo's (verzoek Lucas, 17-08-2026): in het menu tonen we waar
     mogelijk het logo van het spel in plaats van het lijn-icoon. Bestanden staan
     in Shopify -> Inhoud -> Bestanden. Spellen zonder logo houden hun icoon. */
  var CDN = 'https://cdn.shopify.com/s/files/1/0647/0411/9019/files/';
  /* 25-09-2026: het menu toont een logo in een vak van hooguit 64x30 px. We
     vragen de CDN daarom om een kleine versie (past binnen 128x60, scherp op
     retina, zelfde verhouding, niets bijgesneden) i.p.v. het originele
     bestand: samen ~60 KB in plaats van ~350 KB. */
  var LQ = '?width=128&height=60';
  var LOGOS = {
    pokemon:   CDN + 'Pokemon_Trading_Card_Game2.png' + LQ,
    magic:     CDN + 'Lichcards_kopen_Magic_the_Gathering_TCG.png' + LQ,
    onepiece:  CDN + 'logaster-2022-07-one-piece-symbol.png' + LQ,
    yugioh:    CDN + 'Yu-Gi-Oh_Trading_card_game_lichcards_kopen.png' + LQ,
    lorcana:   CDN + 'tcg-logo-lorcana.png' + LQ,
    starwars:  CDN + 'tcg-logo-star-wars-unlimited.png' + LQ,
    digimon:   CDN + 'tcg-logo-digimon-2025.jpg' + LQ,
    fab:       CDN + 'tcg-logo-flesh-and-blood.png' + LQ,
    weiss:     CDN + 'tcg-logo-weiss-schwarz.jpg' + LQ,
    vanguard:  CDN + 'tcg-logo-vanguard.png' + LQ,
    dragonball: CDN + 'tcg-logo-dragon-ball-super.png' + LQ,
    riftbound: CDN + 'tcg-logo-riftbound.png' + LQ,
    minecraft: CDN + 'tcg-logo-minecraft.png' + LQ,
    /* 22-09-2026: hololive en Union Arena kwamen van externe sites (hololive
       bleef leeg, Union Arena een donker blok); nu de eigen bestanden van de
       homepage-tegels, verkleind via de CDN. */
    hololive:  CDN + 'tcg-logo-hololive_1b8a9721-7c34-4b00-8979-0ac1ce1c2cbf.png' + LQ,
    unionarena: CDN + 'tcg-logo-union-arena.png' + LQ,
    lichguard: CDN + 'LichGuard_2.png' + LQ
  };

  /* Volgorde telt: de eerste regel die past, wint. Specifieke namen dus boven
     de brede regels (magic vangt "gathering", sealed vangt "tcg"). */
  var GAMES = [
    { k: 'unionarena',   icon: 'singles',      c: '#000f9f', re: /union[\s_-]?arena/i },
    { k: 'minecraft',    icon: 'minecraft',    c: '#4f7a35', re: /minecraft/i },
    { k: 'adrenalyn',    icon: 'adrenalyn',    c: '#1b6fa8', re: /adrenalyn/i },
    { k: 'altered',      icon: 'altered',      c: '#2f7d6b', re: /altered/i },
    { k: 'hololive',     icon: 'hololive',     c: '#2f93c4', re: /hololive/i },
    { k: 'finalfantasy', icon: 'finalfantasy', c: '#3b5ba5', re: /final\s?fantasy/i },
    { k: 'pokemon',    icon: 'pokemon',    c: '#b58900', re: /pok[eé]mon/i },
    { k: 'magic',      icon: 'magic',      c: '#a8631b', re: /magic|mtg|gathering/i },
    { k: 'onepiece',   icon: 'onepiece',   c: '#b3122b', re: /one[\s-]?piece/i },
    { k: 'yugioh',     icon: 'yugioh',     c: '#6b3fa0', re: /yu[\s-]?gi[\s-]?oh/i },
    { k: 'lorcana',    icon: 'lorcana',    c: '#1d6f83', re: /lorcana/i },
    { k: 'dragonball', icon: 'dragonball', c: '#d1690b', re: /dragon\s?ball/i },
    { k: 'digimon',    icon: 'digimon',    c: '#0b6fb8', re: /digimon/i },
    { k: 'starwars',   icon: 'starwars',   c: '#3f4650', re: /star\s?wars/i },
    { k: 'riftbound',  icon: 'riftbound',  c: '#9c1f8c', re: /riftbound/i },
    { k: 'gundam',     icon: 'gundam',     c: '#b31b34', re: /gundam/i },
    { k: 'fab',        icon: 'fab',        c: '#7c1d38', re: /flesh\s?(and|&)\s?blood/i },
    { k: 'weiss',      icon: 'weiss',      c: '#2f3440', re: /wei(ss|ß)\s?schwarz/i },
    { k: 'vanguard',   icon: 'singles',    c: '#7a1f3d', re: /vanguard|cardfight/i },
    { k: 'sports',     icon: 'sports',     c: '#146c43', re: /sport(s)?[\s-]?(cards|kaarten)/i },
    { k: 'singles',    icon: 'singles',    c: '#000f9f', re: /losse kaarten|singles|einzelkarten|cartes? à l.unité|cartas? sueltas|carte singole/i },
    { k: 'board',      icon: 'board',      c: '#4b5563', re: /bordspel|board\s?game|gezelschap|brettspiel|jeux?\s?de\s?société|juegos?\s?de\s?mesa|giochi?\s?da\s?tavolo/i },
    { k: 'acc',        icon: 'acc',        c: '#4b5563', re: /accessoire|accessory|zubehör|accesorio|accessori|sleeve|kaarthoes|lichguard|toploader/i },
    { k: 'buy',        icon: 'buy',        c: '#146c43', re: /verkopen|inkoop|buylist/i },
    { k: 'sealed',     icon: 'sealed',     c: '#3f4650', re: /^tcg$|sealed/i }
  ];

  function svg(name, cls, game) {
    if (!ICONS[name]) return '';
    return '<svg class="' + (cls || 'lc-navicon') + '" viewBox="0 0 24 24" preserveAspectRatio="xMinYMid meet" aria-hidden="true" focusable="false"' +
      (game ? ' data-game="' + game + '"' : '') + '>' + ICONS[name] + '</svg>';
  }

  function matchGame(text) {
    if (!text) return null;
    for (var i = 0; i < GAMES.length; i++) { if (GAMES[i].re.test(text)) return GAMES[i]; }
    return null;
  }

  /* Keep game-row logo slots aligned. The refined desktop TCG menu uses a
     compact 50px slot; unrelated menus retain their previous dimensions. */
  function lcMegaSize(a, el, h) {
    if (!el || !a.closest('.mega-menu__content')) return;
    if (el.tagName === 'IMG' && a.classList.contains('mega-menu__link--level-2') &&
        a.closest('.lc-menu-grid--tcg')) {
      el.width = 58;
      el.height = 32;
    }
    if ((a.className || '').indexOf('mega-menu__link--level-3') === -1) return;
    var compact = a.closest('.lc-menu-grid--tcg');
    el.style.setProperty('width', compact ? '50px' : '64px', 'important');
    el.style.setProperty('height', compact ? '28px' : h, 'important');
    if (el.tagName === 'IMG') {
      el.width = compact ? 50 : 64;
      el.height = compact ? 28 : parseInt(h, 10);
    }
    el.style.setProperty('margin-right', compact ? '10px' : '12px', 'important');
    el.style.setProperty('flex', 'none', 'important');
  }

  /* 25-09-2026: bovenaan elk uitklappaneel een link naar de hele categorie
     ("Alles in TCG →"). Op iPad opent de eerste tik op "TCG" het paneel; zo is
     de categoriepagina ook vanuit het paneel met één tik te bereiken. Naam en
     adres komen uit het menu zelf, dus ze kloppen in elke taal. */
  function addPanelAllLink(list, parentLink) {
    var wrapper = list.closest('.list-menu--wrapper');
    if (!wrapper || !parentLink || wrapper.querySelector('.lc-mega-all')) return;
    var href = parentLink.getAttribute('href') || parentLink.getAttribute('data-lc-menu-destination');
    var name = (parentLink.textContent || '').replace(/\s+/g, ' ').trim();
    if (!href || !name || href.charAt(0) === '#') return;
    var row = document.createElement('div');
    row.className = 'lc-mega-all-row page-width page-width--page-width';
    var a = document.createElement('a');
    a.className = 'lc-mega-all';
    a.href = href;
    a.appendChild(document.createTextNode(tr('panelAll').replace('{x}', name)));
    var arrow = document.createElement('span');
    arrow.className = 'lc-mega-all__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '\u2192';
    a.appendChild(arrow);
    row.appendChild(a);
    wrapper.insertBefore(row, wrapper.firstChild);
  }

  /* Desktop-only presentation groups. Use stable collection destinations, not
     translated menu labels; keep the theme's own hover and navigation intact. */
  function refineDesktopNav(scope) {
    var lists = findWithin(scope, '#header-group .header__inline-menu .mega-menu__list');
    Array.prototype.forEach.call(lists, function (list) {
      var columns = Array.prototype.filter.call(list.children, function (el) {
        return el.classList.contains('mega-menu__column');
      });
      if (!columns.length) return;
      var menu = list.closest('details.mega-menu');
      var parentLink = menu && menu.querySelector('summary a[href], summary [data-lc-menu-destination]');
      var parentHref = parentLink && (parentLink.getAttribute('href') || parentLink.getAttribute('data-lc-menu-destination'));
      /* De menu-id's (HeaderMenu-tcg, HeaderMenu-accessoires) zijn in elke taal
         gelijk; de collectie-URL's worden per taal vertaald. */
      var summary = menu && menu.querySelector('summary[id]');
      var menuId = summary ? summary.id : '';
      var gameColumns = columns.filter(function (column) {
        var heading = column.querySelector('a.mega-menu__link--level-2');
        var game = heading && matchGame(heading.textContent);
        return game && /^(pokemon|yugioh|magic)$/.test(game.k);
      });
      if ((menuId === 'HeaderMenu-tcg' || (parentHref && /\/collections\/alle-tcg-producten(?:[/?#]|$)/i.test(parentHref))) && columns.length === 4 && gameColumns.length === 3) {
        list.classList.add('lc-menu-grid--tcg');
        columns.forEach(function (column) {
          var isGame = gameColumns.indexOf(column) !== -1;
          column.classList.add(isGame ? 'lc-menu__game-column' : 'lc-menu__other-column');
          if (isGame) {
            Array.prototype.forEach.call(column.querySelectorAll('a.mega-menu__link--level-3'), function (a) {
              a.classList.add('lc-menu__category-link');
            });
          }
        });
      }
      try { addPanelAllLink(list, parentLink); } catch (e) {}
      if (menuId === 'HeaderMenu-accessoires' || (parentHref && /\/collections\/tcg-accessoires(?:[/?#]|$)/i.test(parentHref))) {
        list.classList.add('lc-menu-grid--accessories');
        Array.prototype.forEach.call(list.querySelectorAll('a.mega-menu__link'), function (a) {
          a.classList.add('lc-menu__category-link');
        });
      }
    });
  }

  /* 1 - Iconen aan de menu-items hangen. Het thema tekent bij sommige items
     zelf een icoon, maar niet als <svg>: het gebruikt ::before met mask-image.
     Dat is niet met querySelector te vinden, dus dat icoon wordt in
     lichcards-design-cards.css met CSS verborgen. */
  function decorateNav(scope) {
    var links = findWithin(scope, '#header-group a, #header-group summary [data-lc-menu-destination]');
    Array.prototype.forEach.call(links, function (a) {
      if (a.closest('.lc-utility') || a.closest('.lc-mega') || a.classList.contains('lc-mega-all')) return;

      var mine = a.querySelector('.lc-navicon');
      if (a.classList.contains('lc-menu__category-link')) {
        if (mine) mine.remove();
        a.classList.remove('lc-has-navicon');
        return;
      }
      if (a.querySelector('svg:not(.lc-navicon), img:not(.lc-navlogo)')) {
        if (mine) mine.remove();
        a.classList.remove('lc-has-navicon');
        return;
      }
      if (mine) return;

      var label = (a.textContent || '').trim();
      if (!label || label.length > 40) return;
      var g = matchGame(label);

      /* A generic third-level label such as “Engelse producten” carries no
         game name of its own. In that case inherit the game from its mega-menu
         column heading, so every row keeps the same recognisable game logo. */
      if (!g && a.closest('.mega-menu__content') &&
          (a.className || '').indexOf('mega-menu__link--level-3') !== -1) {
        var sublist = a.closest('ul.list-unstyled');
        var column = sublist && sublist.parentElement;
        var heading = column && column.querySelector('a.mega-menu__link--level-2');
        g = matchGame(heading && heading.textContent);
      }
      if (!g) return;

      var logoUrl = LOGOS[g.k];
      if (g.k === 'acc') logoUrl = /lichguard/i.test(label) ? LOGOS.lichguard : null;
      if (logoUrl) {
        a.classList.add('lc-has-navicon');
        a.insertAdjacentHTML(
          'afterbegin',
          '<img class="lc-navicon lc-navlogo" data-game="' + g.k + '" src="' + logoUrl + '" alt="" width="46" height="20" loading="lazy"' +
            ' style="width:46px;height:20px;object-fit:contain;object-position:left center;flex:none;display:inline-block;">'
        );
        lcMegaSize(a, a.querySelector('img.lc-navlogo'), '30px');
        return;
      }

      a.classList.add('lc-has-navicon');
      a.insertAdjacentHTML('afterbegin', svg(g.icon, 'lc-navicon', g.k));
      var ic = a.querySelector('.lc-navicon');
      if (ic) ic.style.color = g.c;
      lcMegaSize(a, ic, '26px');
    });
  }

  /* Dubbele ingangen uit het hoofdmenu halen (staan al in de utility-balk) */
  function hideRedundantNavItems(scope) {
    if (!MENU_VERBERGEN.length) return;
    var links = findWithin(scope, '#header-group a');
    Array.prototype.forEach.call(links, function (a) {
      if (a.closest('.lc-utility') || a.closest('.lc-mega')) return;
      var label = (a.textContent || '').trim().toLowerCase();
      if (MENU_VERBERGEN.indexOf(label) === -1) return;
      var item = a.closest('li') || a;
      if (item.dataset.lcHidden) return;
      item.dataset.lcHidden = '1';
      item.style.display = 'none';
    });
  }

  /* 4 - Utility-balk boven de header */
  function buildUtilityBar() {
    if (document.querySelector('.lc-utility')) return;
    var host = document.getElementById('header-group');
    if (!host || !host.parentNode) return;

    var left = [
      { t: tr('shopCity'), h: lcPath('/pages/contact'), i: 'store' },
      { t: LC_SHIPPING_LABEL || tr('freeShipping'), h: lcPath('/policies/shipping-policy'), i: 'truck' }
    ];
    var right = [
      { t: tr('sellCards'), h: lcPath('/pages/pokemon-kaarten-verkopen'), i: 'buy' },
      { t: tr('loyalty'), h: lcPath('/pages/spaarpunten'), i: 'star' },
      { t: tr('contact'), h: lcPath('/pages/contact'), i: 'phone' }
    ];

    function list(items, cls) {
      return '<ul class="lc-utility__list ' + cls + '">' + items.map(function (it) {
        return '<li><a href="' + it.h + '">' + (it.i ? svg(it.i, 'lc-uicon') : '') + '<span>' + esc(it.t) + '</span></a></li>';
      }).join('') + '</ul>';
    }

    var bar = document.createElement('div');
    bar.className = 'lc-utility';
    bar.innerHTML = '<div class="lc-utility__in">' + list(left, 'lc-utility__list--left') + list(right, 'lc-utility__list--right') + '</div>';
    host.parentNode.insertBefore(bar, host);
  }

  

  

  /* 16b - Lang knoplabel past niet op een smalle kaart */
  function shortenAddLabels(scope) {
    var narrow = window.matchMedia('(max-width: 899px)').matches;
    var btns = findWithin(scope, '.card .quick-add__submit, .card .add-to-cart-button');
    Array.prototype.forEach.call(btns, function (btn) {
      var span = btn.querySelector('span:not(.sold-out-message):not(.visually-hidden)') || btn;
      var full = btn.dataset.lcLabel;
      if (full === undefined) {
        full = (span.textContent || '').trim();
        if (!full || full.length < 4) return;
        btn.dataset.lcLabel = full;
        if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', full);
      }
      var compactKey = /option|optie|choisir|auswähl|elegir|scegli/i.test(full) ? 'shortOptions' : 'shortAdd';
      var want = (narrow && full.length > 16) ? tr(compactKey) : full;
      if ((span.textContent || '').trim() !== want) span.textContent = want;
    });
  }

  /* 19 - EUR achter de prijs weghalen */
  var MONEY = /(\s*)(EUR|USD|GBP)\b/g;

  function stripCurrencyCode(root) {
    var selector = '[class*="price"], .money, .lc-top3__price';
    var prices = findWithin(root, selector);
    var priceSet = new Set(prices);
    prices.forEach(function (price) {
      var parent = price.parentElement && price.parentElement.closest(selector);
      if (parent && priceSet.has(parent)) return;
      var walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (!n.nodeValue || n.nodeValue.indexOf('EUR') === -1) return NodeFilter.FILTER_REJECT;
          var p = n.parentElement;
          if (!p || p.closest('script,style,textarea,input,select,[data-lc-keep-currency]')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (node) {
        node.nodeValue = node.nodeValue.replace(MONEY, '').replace(/\s{2,}/g, ' ');
      });
    });
  }

  function readPrice(priceEl) {
    if (!priceEl) return null;
    function txt(el) { return el ? el.textContent.replace(MONEY, '').trim() : ''; }
    var wasEl = priceEl.querySelector('.price__sale s.price-item--regular, .price__sale del, s.price-item--regular, del');
    var nowEl = priceEl.querySelector('.price-item--sale') ||
                priceEl.querySelector('.price__regular .price-item--regular') ||
                priceEl.querySelector('.price-item--regular');
    return { was: txt(wasEl), now: txt(nowEl) };
  }

  function parseMoney(txt) {
    if (!txt) return null;
    var m = String(txt).replace(/\s/g, '').match(/([\d.]+,\d{2}|\d+[.,]\d{2}|\d+)/);
    if (!m) return null;
    var raw = m[1];
    if (raw.indexOf(',') > -1) raw = raw.replace(/\./g, '').replace(',', '.');
    var v = parseFloat(raw);
    return isNaN(v) ? null : v;
  }

  

  /* 20 + 21 - Badges */
  function upgradeBadges(scope) {
    var cards = findWithin(scope, '.card-wrapper, .product-card-wrapper');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.lcBadges) return;
      card.dataset.lcBadges = '1';

      var holder = card.querySelector('.card__badge');
      var priceEl = card.querySelector('.price');

      if (holder && priceEl) {
        var p = readPrice(priceEl);
        var was = parseMoney(p && p.was);
        var now = parseMoney(p && p.now);
        if (was && now && was > now) {
          var pct = Math.round((1 - now / was) * 100);
          if (pct > 0) {
            var sale = holder.querySelector('.sale-badge') || holder.querySelector('.badge');
            if (sale) {
              sale.textContent = '−' + pct + '%';
              sale.classList.add('lc-badge', 'lc-badge--sale');
            }
          }
        }
      }

      Array.prototype.forEach.call(card.querySelectorAll('.card__badge .badge, .card__badge span'), function (b) {
        var t = (b.textContent || '').trim().toLowerCase();
        b.classList.add('lc-badge');
        if (/uitverkocht|sold\s?out|niet op voorraad|ausverkauft|épuisé|agotado|esaurito/.test(t)) b.classList.add('lc-badge--gone');
        else if (/nieuw|new|neu|nouve(?:au|lle)|nuev[oa]|nuov[oa]/.test(t)) b.classList.add('lc-badge--new');
        else if (/pre[\s-]?order|verwacht|vorbestell|précommande|preventa|preordine/.test(t)) b.classList.add('lc-badge--pre');
        else if (/aanbieding|sale|korting|angebot|rabatt|promotion|remise|oferta|descuento|offerta|sconto|%|−/.test(t)) b.classList.add('lc-badge--sale');
      });
    });
  }


  /* 13 - Broodkruimels */
  function buildBreadcrumb() {
    if (document.querySelector('.lc-lg')) return;
    if (document.querySelector('.lc-breadcrumb')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;

    var m = BODY.className.match(/template-([a-z]+)/);
    var type = m ? m[1] : '';
    if (type !== 'collection' && type !== 'product') return;

    var trail = [{ t: tr('home'), h: lcPath('/') }];
    var h1 = main.querySelector('h1');

    if (type === 'product') {
      var g = matchGame(document.title);
      var handles = { pokemon: 'pokemon-tcg', magic: 'mtg', onepiece: 'one-piece-booster-packs', yugioh: 'yu-gi-oh-tcg', lorcana: 'lorcana', dragonball: 'dragon-ball-super', digimon: 'digimon', starwars: 'star-wars-unlimited', riftbound: 'riftbound', board: 'bord-gezelschapsspellen', acc: 'tcg-accessoires' };
      var names = { pokemon: 'Pokémon', magic: 'Magic: The Gathering', onepiece: 'One Piece', yugioh: 'Yu-Gi-Oh!', lorcana: 'Disney Lorcana', dragonball: 'Dragon Ball Super', digimon: 'Digimon', starwars: 'Star Wars: Unlimited', riftbound: 'Riftbound', board: tr('boardGames'), acc: tr('accessories') };
      if (g && handles[g.k]) trail.push({ t: names[g.k], h: lcPath('/collections/' + handles[g.k]) });
    }
    if (h1) trail.push({ t: h1.textContent.trim(), h: null });
    if (trail.length < 2) return;

    var nav = document.createElement('nav');
    nav.className = 'lc-breadcrumb';
    nav.setAttribute('aria-label', tr('breadcrumb'));
    nav.innerHTML = trail.map(function (s, i) {
      var last = i === trail.length - 1;
      var txt = esc(s.t.length > 60 ? s.t.slice(0, 57) + '…' : s.t);
      var el = (last || !s.h) ? '<span aria-current="page">' + txt + '</span>' : '<a href="' + s.h + '">' + txt + '</a>';
      return (i ? '<span class="lc-breadcrumb__sep">/</span>' : '') + el;
    }).join('');
    main.insertBefore(nav, main.firstChild);
  }

  /* 31 - Kleuraccent per spel */
  function applyGameAccent() {
    if (document.querySelector('.lc-lg')) return;
    if (BODY.className.indexOf('template-collection') === -1) return;
    var h1 = document.querySelector('#MainContent h1');
    if (!h1) return;
    var g = matchGame(h1.textContent);
    if (!g) return;
    BODY.setAttribute('data-lc-game', g.k);
    BODY.style.setProperty('--lc-game', g.c);

    var prev = h1.previousElementSibling;
    if (!prev || !prev.classList.contains('lc-collection-flag')) {
      var flag = document.createElement('div');
      flag.className = 'lc-collection-flag';
      h1.parentNode.insertBefore(flag, h1);
    }
    if (!h1.querySelector('.lc-navicon')) {
      h1.insertAdjacentHTML('afterbegin', svg(g.icon, 'lc-navicon', g.k));
      var ic = h1.querySelector('.lc-navicon');
      if (ic) {
        ic.style.width = '0.75em'; ic.style.height = '0.75em'; ic.style.flex = 'none';
        ic.style.marginInlineEnd = '.3em'; ic.style.color = g.c;
        ic.style.verticalAlign = 'baseline'; ic.style.display = 'inline-block';
      }
    }
  }

  

  /* Bug uit de audit: sticky koopknop overlapte het label Aantal */
  function fixStickyOverlap() {
    if (BODY.className.indexOf('template-product') === -1) return;
    var qty = document.querySelector('.product-form__quantity, [class*="quantity"]');
    if (!qty) return;
    var label = qty.querySelector('label');
    if (label) {
      label.style.position = 'relative';
      label.style.zIndex = '2';
      label.style.background = '#fff';
      label.style.paddingInlineEnd = '6px';
    }
  }

  /* Punt 12 (winkelaudit ronde 2, 19-09-2026) — mobiel filtermenu, site-audit 04-09 punt B1.
     Zet het aantal actieve filters als teller op de Filter-knop (badge .lc-filter-count) en als
     data-lc-filter-count op de knop en op het mobiele filterformulier; de CSS in
     assets/lichcards-filters-20260904.css verbergt daarmee "Alles wissen" als er niets te wissen is.
     Telt de actieve-filterchips die het thema zelf rendert (één chip = één filter, ook bij
     samengevoegde producttypes); zonder chipblok tellen de filter.-parameters in de URL.
     Idempotent, en via de MutationObserver hieronder ook na elke AJAX-filterwissel. */
  function countActiveFilters() {
    var block = document.querySelector('.active-facets-mobile') || document.querySelector('.active-facets');
    if (block) {
      var n = 0;
      Array.prototype.forEach.call(block.querySelectorAll('facet-remove'), function (chip) {
        if (chip.classList.contains('active-facets__button-wrapper')) return;
        if (chip.hidden || chip.style.display === 'none' || !chip.querySelector('a[href]')) return;
        n++;
      });
      return n;
    }
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return 0; }
    var count = 0, price = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') !== 0 || value === '') return;
      if (key.indexOf('filter.v.price') === 0) { if (!price) { price = true; count++; } return; }
      count++;
    });
    return count;
  }

  function updateFilterCount() {
    var openers = document.querySelectorAll('.mobile-facets__open');
    var forms = document.querySelectorAll('form.mobile-facets');
    if (!openers.length && !forms.length) return;
    var n = String(countActiveFilters());
    Array.prototype.forEach.call(forms, function (form) {
      if (form.getAttribute('data-lc-filter-count') !== n) form.setAttribute('data-lc-filter-count', n);
    });
    Array.prototype.forEach.call(openers, function (opener) {
      if (opener.getAttribute('data-lc-filter-count') !== n) opener.setAttribute('data-lc-filter-count', n);
      var badge = opener.querySelector('.lc-filter-count');
      if (n !== '0') {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'lc-filter-count';
          badge.setAttribute('aria-hidden', 'true');
          opener.appendChild(badge);
        }
        if (badge.textContent !== n) badge.textContent = n;
      } else if (badge && badge.parentNode) {
        badge.parentNode.removeChild(badge);
      }
    });
  }

  var filterCountPending = null;
  function scheduleFilterCount() {
    if (filterCountPending) return;
    filterCountPending = requestAnimationFrame(function () {
      filterCountPending = null;
      try { updateFilterCount(); } catch (e) {}
    });
  }

  function runOnce() {
    try { buildUtilityBar(); } catch (e) {}
    
    try { buildBreadcrumb(); } catch (e) {}
    try { applyGameAccent(); } catch (e) {}
    try { fixStickyOverlap(); } catch (e) {}
  }

  function runNavigation(scope) {
    try { refineDesktopNav(scope); } catch (e) {}
    try { decorateNav(scope); } catch (e) {}
    try { hideRedundantNavItems(scope); } catch (e) {}
  }

  function runContent(scope) {
    try { stripCurrencyCode(scope); } catch (e) {}
    try { upgradeBadges(scope); } catch (e) {}
    try { shortenAddLabels(scope); } catch (e) {}
    try { initCategoryRails(scope); } catch (e) {}
  }

  function initCategoryRails(scope) {
    Array.prototype.forEach.call(findWithin(scope, '[data-lc-category-rail]'), function (rail) {
      if (rail._lcSyncCategoryRail) { rail._lcSyncCategoryRail(); return; }
      var track = rail.querySelector('[data-lc-chip-track]');
      var previous = rail.querySelector('[data-lc-chip-step="-1"]');
      var next = rail.querySelector('[data-lc-chip-step="1"]');
      if (!track || !previous || !next) return;
      var rtl = window.getComputedStyle(track).direction === 'rtl';
      var sync = function () {
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var position = Math.max(0, Math.min(max, Math.abs(track.scrollLeft)));
        previous.disabled = position <= 1;
        next.disabled = position >= max - 1;
        rail.classList.toggle('lc-fbar__rail--overflow', max > 1);
      };
      rail._lcSyncCategoryRail = sync;
      track.addEventListener('scroll', sync, { passive: true });
      rail.addEventListener('click', function (event) {
        var control = event.target.closest('[data-lc-chip-step]');
        if (!control || !rail.contains(control) || control.disabled) return;
        var step = Number(control.getAttribute('data-lc-chip-step'));
        var distance = Math.max(140, track.clientWidth * .75);
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: distance * step * (rtl ? -1 : 1), behavior: reduced ? 'instant' : 'smooth' });
      });
      sync();
    });
  }

  /* 28 - Filterzijbalk in- en uitklappen (collecties, ronde 6, 26-09-2026). Knoppen: snippets/lc-filter-toggle.liquid.
     De klasse lc-filters-hidden op <html> zet een inline script in sections/main-collection-product-grid.liquid al
     vóór het tekenen, zodat een eerder verborgen zijbalk niet eerst verschijnt en dan wegspringt. */
  var filterToggleReady = false;
  function syncFilterToggles() {
    var hidden = document.documentElement.classList.contains('lc-filters-hidden');
    Array.prototype.forEach.call(document.querySelectorAll('[data-lc-filter-toggle]'), function (btn) {
      btn.setAttribute('aria-expanded', String(!hidden));
    });
  }
  function initFilterToggle() {
    if (filterToggleReady) return;
    filterToggleReady = true;
    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-lc-filter-toggle]') : null;
      if (!btn) return;
      event.preventDefault();
      var hidden = document.documentElement.classList.toggle('lc-filters-hidden');
      try { window.localStorage.setItem('lcFiltersHidden', hidden ? '1' : '0'); } catch (e) {}
      syncFilterToggles();
      var next = document.querySelector(hidden ? '.lc-ftoggle--show' : '.lc-ftoggle--hide');
      if (next && next.offsetParent !== null) next.focus({ preventScroll: true });
    });
    syncFilterToggles();
  }

  function boot() {
    runOnce();
    try { initFilterToggle(); } catch (e) {}
    runNavigation(document.getElementById('header-group') || document);
    runContent(document);
    
    try { updateFilterCount(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var pending = null;
  var navigationRoots = [];
  var contentRoots = [];
  var contentSelector = '[data-lc-category-rail], .card-wrapper, .product-card-wrapper, [class*="price"], .money, .lc-top3__price, .card .quick-add__submit, .card .add-to-cart-button';

  function queueRoot(roots, scope) {
    if (!scope || !scope.isConnected || roots.some(function (root) { return root === scope || root.contains(scope); })) return;
    for (var i = roots.length - 1; i >= 0; i--) {
      if (scope.contains(roots[i])) roots.splice(i, 1);
    }
    roots.push(scope);
  }

  function queueChangedNode(node, target) {
    var element = node.nodeType === 1 ? node : target;
    if (!element || element.nodeType !== 1 || !element.isConnected) return;
    if (element.closest('script,style,.lc-navicon,.lc-utility')) return;
    var header = element.closest('#header-group') || element.querySelector('#header-group');
    if (header) {
      var menu = element.closest('.mega-menu__list');
      var anchor = element.closest('a');
      if (menu) queueRoot(navigationRoots, menu);
      else if (anchor) queueRoot(navigationRoots, anchor);
      else if (element === header || element.contains(header)) queueRoot(navigationRoots, header);
      else if (element.querySelector('a')) queueRoot(navigationRoots, element);
    }
    var content = element.closest(contentSelector);
    if (content) queueRoot(contentRoots, content);
    else if (element.querySelector(contentSelector)) queueRoot(contentRoots, element);
  }

  function scheduleChanges() {
    if (!navigationRoots.length && !contentRoots.length) return;
    if (pending) return;
    pending = requestAnimationFrame(function () {
      pending = null;
      var menus = navigationRoots.splice(0);
      var content = contentRoots.splice(0);
      menus.forEach(function (scope) { if (scope.isConnected) runNavigation(scope); });
      content.forEach(function (scope) { if (scope.isConnected) runContent(scope); });
    });
  }

  var filterCountSelector = '.active-facets-mobile, .active-facets, .mobile-facets__open, form.mobile-facets';

  function nodeHasFilterControl(node, selector) {
    return node.nodeType === 1 && (node.matches(selector) || !!node.querySelector(selector));
  }

  function filterCountChanged(record) {
    var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
    if (target && target.closest('.active-facets-mobile, .active-facets')) return true;
    return Array.prototype.some.call(record.addedNodes, function (node) {
      return nodeHasFilterControl(node, filterCountSelector);
    }) || Array.prototype.some.call(record.removedNodes, function (node) {
      return nodeHasFilterControl(node, filterCountSelector);
    });
  }

  var obs = new MutationObserver(function (records) {
    var countChanged = false;
    var togglesChanged = false;
    records.forEach(function (record) {
      if (!countChanged && filterCountChanged(record)) countChanged = true;
      Array.prototype.forEach.call(record.addedNodes, function (node) {
        queueChangedNode(node, record.target);
        if (!togglesChanged && nodeHasFilterControl(node, '[data-lc-filter-toggle]')) togglesChanged = true;
      });
    });
    scheduleChanges();
    if (countChanged) scheduleFilterCount();
    if (togglesChanged) {
      try { syncFilterToggles(); } catch (e) {}
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('popstate', scheduleFilterCount);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || event.target.nodeType !== 1) return;
    runOnce();
    queueChangedNode(event.target, event.target);
    scheduleChanges();
    
  });

  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      try { shortenAddLabels(document); } catch (e) {}
      try { initCategoryRails(document); } catch (e) {}
    }, 150);
  });
})();


/* Lichcards 25-09-2026 — hoofdmenu
   1. Desktop: het uitklapmenu (TCG / Accessoires) werd pas bij de eerste muisbeweging opgehaald,
      waardoor het eerste paneel even leeg bleef. Nu wordt het opgehaald zodra de pagina rustig is
      (alleen op apparaten met muis) of zodra de muis het menu nadert.
   2. Mobiel: het zoek-icoon opende de zoeklade met de focus op de sluitknop, waardoor je nog een keer
      moest tikken. Nu komt de cursor meteen in het zoekveld (ook op iPhone, via een tijdelijk veld). */
(function () {
  'use strict';
  try {
    if (window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1025px)').matches) {
      // Mislukt het ophalen (bijv. een tijdelijke serverfout), dan mag de volgende muisbeweging
      // over het menu het opnieuw proberen; het thema zelf probeert het anders nooit meer.
      var allowRetry = function (fetcher) {
        if (fetcher._lcRetryPending) return;
        fetcher._lcRetryPending = true;
        window.setTimeout(function () {
          fetcher._lcRetryPending = false;
          var target = document.getElementById(fetcher.dataset.targetId);
          if (!target || target.hasAttribute('data-loaded') || !fetcher._initialized) return;
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('section_id', fetcher.dataset.sectionId);
            if (typeof sectionRenderCache !== 'undefined' && sectionRenderCache.get(url.toString()) === '') {
              sectionRenderCache.delete(url.toString());
            }
          } catch (e) {}
          fetcher._initialized = false;
        }, 10000);
      };
      var prefetchMenu = function () {
        var fetchers = document.querySelectorAll('#header-group .header__inline-menu section-fetcher');
        Array.prototype.forEach.call(fetchers, function (fetcher) {
          if (typeof fetcher.initialize === 'function') {
            try { fetcher.initialize(); } catch (e) {}
            var target = document.getElementById(fetcher.dataset.targetId);
            if (target && !target.hasAttribute('data-loaded')) allowRetry(fetcher);
          }
        });
      };
      var whenIdle = function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(prefetchMenu, { timeout: 3000 });
        else window.setTimeout(prefetchMenu, 1500);
      };
      if (document.readyState === 'complete') whenIdle();
      else window.addEventListener('load', whenIdle, { once: true });
      var nav = document.querySelector('#header-group .header__inline-menu');
      if (nav) nav.addEventListener('pointerenter', prefetchMenu);
    }
  } catch (e) {}

  document.addEventListener('click', function (event) {
    var opener = event.target && event.target.closest ? event.target.closest('side-drawer-opener[data-side-drawer="#Drawer-Search"]') : null;
    if (!opener) return;
    var input = document.getElementById('Search-In-Modal-Mobile');
    if (!input) return;
    var proxy = document.createElement('input');
    proxy.type = 'text';
    proxy.setAttribute('aria-hidden', 'true');
    proxy.tabIndex = -1;
    proxy.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px;';
    document.body.appendChild(proxy);
    try { proxy.focus({ preventScroll: true }); } catch (e) {}
    var focusAttempted = false;
    var moveFocus = function () {
      if (focusAttempted) return;
      focusAttempted = true;
      var style = window.getComputedStyle(input);
      if (drawer && drawer.isConnected && input.isConnected && drawer.classList.contains('open') &&
          !drawer.lcClosing && !drawer.hasAttribute('data-lc-closing') &&
          drawer.drawerTransitionGeneration === drawerGeneration && !input.closest('[inert], [hidden]') &&
          input.getClientRects().length && style.visibility !== 'hidden' && style.visibility !== 'collapse') {
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      }
      if (proxy.parentNode) proxy.parentNode.removeChild(proxy);
    };
    var drawer = document.getElementById('Drawer-Search');
    var drawerGeneration = drawer && drawer.drawerTransitionGeneration;
    if (drawer) {
      drawer.addEventListener('transitionend', function () { window.setTimeout(moveFocus, 30); }, { once: true });
    }
    window.setTimeout(moveFocus, 700);
  });
})();


/* Lichcards 25-09-2026 — hoofdmenu op iPad en andere aanraakschermen
   Het thema opent de uitklapmenu's (TCG, Accessoires) alleen met een muis. Op een iPad ging
   een tik op "TCG" daardoor meteen naar de categoriepagina en kreeg je het menu nooit te zien.
   Nu: de eerste tik opent het paneel, een tweede tik op dezelfde knop opent de categoriepagina
   (en bovenaan het paneel staat "Alles in … →"). Tik ernaast sluit het paneel.
   Met een muis of trackpad verandert er niets. */
(function () {
  'use strict';
  var ITEM = '#header-group .header__inline-menu details[activate-event="hover"]';
  var lastPointer = { type: '', time: 0 };

  function isOpen(details) {
    if (details._lcShown === true) return true;          // Safari-afhandeling van het thema
    if (details.isOpen === true) return true;            // thema-dropdown (Chrome, Edge, Firefox)
    return details.getAttribute('open') === 'true';
  }

  function closeMenu(details) {
    clearTimeout(details._hoverCloseTimer);
    clearTimeout(details._lcCloseTimer);
    if (details._lcShown && typeof details._lcClose === 'function') { details._lcClose(); return; }
    if (details.elements && typeof details.close === 'function') { details.close(); return; }
    details.removeAttribute('open');
  }

  function openMenu(details) {
    var fetcher = details.querySelector('section-fetcher');
    if (fetcher && typeof fetcher.initialize === 'function') {
      try { fetcher.initialize(); } catch (e) {}
    }
    var list = details.parentElement && details.parentElement.closest('ul');
    if (list) {
      Array.prototype.forEach.call(list.querySelectorAll('details[activate-event="hover"]'), function (other) {
        if (other !== details && isOpen(other)) closeMenu(other);
      });
    }
    var summary = details.querySelector('summary');
    if (details.dataset.lcSafariHover && summary) {
      summary.dispatchEvent(new MouseEvent('mouseenter'));
      return;
    }
    if (details.elements && 'isOpen' in details) {
      details.isOpen = true;
      return;
    }
    details.setAttribute('open', 'true');
  }

  function isTouchClick(event) {
    if (event.pointerType === 'touch' || event.pointerType === 'pen') return true;
    if (event.pointerType === 'mouse') return false;
    return (lastPointer.type === 'touch' || lastPointer.type === 'pen') && Date.now() - lastPointer.time < 1500;
  }

  document.addEventListener('pointerdown', function (event) {
    lastPointer = { type: event.pointerType, time: Date.now() };
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    var target = event.target && event.target.closest ? event.target : null;
    var here = target ? target.closest(ITEM) : null;
    // Stand vóór deze tik onthouden: de muis-nabootsing van iOS opent het paneel soms al
    // vóórdat de klik binnenkomt.
    if (here) here._lcWasOpen = isOpen(here);
    Array.prototype.forEach.call(document.querySelectorAll(ITEM), function (details) {
      if (details !== here && isOpen(details)) closeMenu(details);
    });
  }, true);

  // Na een tik stuurt de browser soms een nagebootste "muis verlaat het menu" (mouseleave),
  // waarop het thema het paneel meteen weer sluit. Kort na een tik negeren we die voor de
  // menu-items; sluiten gebeurt dan door ernaast te tikken (hierboven).
  document.addEventListener('mouseleave', function (event) {
    var target = event.target;
    if (!target || target.nodeType !== 1 || !target.matches(ITEM)) return;
    if ((lastPointer.type === 'touch' || lastPointer.type === 'pen') && Date.now() - lastPointer.time < 2000) {
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (!isTouchClick(event)) return;
    var target = event.target && event.target.closest ? event.target : null;
    var summary = target ? target.closest('summary') : null;
    var details = summary ? summary.parentElement : null;
    if (!details || !details.matches(ITEM)) return;
    if (!window.matchMedia('(min-width: 1025px)').matches) return;
    var wasOpen = details._lcWasOpen === true;
    details._lcWasOpen = false;
    var link = target.closest('a[href]');
    if (wasOpen && link) return;                  // tweede tik op de naam: gewoon naar de pagina
    event.preventDefault();
    event.stopPropagation();
    if (wasOpen) closeMenu(details);              // tweede tik naast de naam: paneel dicht
    else openMenu(details);
  }, true);
})();


/* Lichcards 25-09-2026 — het Lichcards-logo in de menubalk leeft: het gekleurde wiel rolt mee als je scrollt
   (één rondje per ~1200 px) en maakt een zwiep met een klein "sprongetje" van de poppetjes als je er met de
   muis overheen gaat. Het wiel is een vectorkopie van het logo (snippets/header-logo.liquid). Wie in het
   besturingssysteem minder beweging heeft ingesteld, ziet een stilstaand logo. */
(function () {
  'use strict';
  var rolls = document.querySelectorAll('.lc-logo-wheel__roll');
  if (!rolls.length) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var queued = false;
  var scrollPosition = 0;
  var apply = function () {
    queued = false;
    var deg = (scrollPosition * 0.3) % 360;
    for (var i = 0; i < rolls.length; i++) rolls[i].style.setProperty('--lc-roll', deg.toFixed(1) + 'deg');
  };
  window.addEventListener('scroll', function () {
    scrollPosition = window.scrollY;
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }, { passive: true });
  queued = true;
  window.requestAnimationFrame(apply);

  Array.prototype.forEach.call(document.querySelectorAll('.header__heading-link'), function (link) {
    var mark = link.querySelector('.lc-logo-wheel__mark');
    if (!mark) return;
    var turns = 0;
    var spin = function () {
      turns += 1;
      mark.style.setProperty('--lc-spin', (turns * 360) + 'deg');
      link.classList.remove('is-spinning');
      void link.offsetWidth;
      link.classList.add('is-spinning');
    };
    link.addEventListener('mouseenter', spin);
    link.addEventListener('focus', spin);
  });
})();


/* Lichcards 25-09-2026 (ronde 5) — losse kaarten op de productpagina kantelen mee met de muis, met een
   glansvlek die de muis volgt ("de kaart in je hand"). Alleen bij losse kaarten (html.lc-is-single), alleen
   met een echte muis en niet bij 'minder beweging'. De klik om in te zoomen blijft gewoon werken.
   CSS: laag r5-polish in lichcards-bundle-20260921-v2.css. */
(function () {
  'use strict';
  var html = document.documentElement;
  if (!html.classList.contains('lc-is-card')) return;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  /* 26-09-2026 (ronde 6): de glans- en holo-laag precies over de kaart zelf leggen, niet over het hele fotovlak
     (de foto staat met object-fit: contain en wat witruimte in dat vlak). */
  var measure = function (media) {
    var img = media.querySelector('img');
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    var cs = window.getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
    var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var aw = img.clientWidth - pl - pr, ah = img.clientHeight - pt - pb;
    if (aw <= 0 || ah <= 0) return;
    var ir = img.naturalWidth / img.naturalHeight;
    var w = aw, h = aw / ir;
    if (h > ah) { h = ah; w = ah * ir; }
    media.style.setProperty('--lc-hx', (img.offsetLeft + pl + (aw - w) / 2).toFixed(1) + 'px');
    media.style.setProperty('--lc-hy', (img.offsetTop + pt + (ah - h) / 2).toFixed(1) + 'px');
    media.style.setProperty('--lc-hw', w.toFixed(1) + 'px');
    media.style.setProperty('--lc-hh', h.toFixed(1) + 'px');
  };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cur = null, raf = 0, px = 0, py = 0;
  var apply = function () {
    raf = 0;
    if (!cur) return;
    cur.style.setProperty('--lc-rx', (py * -7).toFixed(2) + 'deg');
    cur.style.setProperty('--lc-ry', (px * 9).toFixed(2) + 'deg');
    cur.style.setProperty('--lc-gx', (50 + px * 46).toFixed(1) + '%');
    cur.style.setProperty('--lc-gy', (50 + py * 46).toFixed(1) + '%');
  };
  var release = function () {
    if (!cur) return;
    cur.classList.remove('lc-tilt');
    cur.style.removeProperty('--lc-rx');
    cur.style.removeProperty('--lc-ry');
    cur = null;
  };
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var slide = e.target && e.target.closest ? e.target.closest('.product-media-container--zoomable') : null;
    var media = slide ? slide.querySelector('.product-media') : null;
    if (media !== cur) {
      release();
      if (!media) return;
      cur = media;
      measure(cur);
      cur.classList.add('lc-tilt');
    }
    if (!cur) return;
    var r = cur.getBoundingClientRect();
    if (!r.width || !r.height) return;
    px = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width) * 2 - 1));
    py = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height) * 2 - 1));
    if (!raf) raf = window.requestAnimationFrame(apply);
  }, { passive: true });
  document.documentElement.addEventListener('mouseleave', release);
  window.addEventListener('blur', release);
})();


/* Lichcards 26-09-2026 (ronde 6) — prijs/voorraad-vlak onder de productfoto (snippets/lc-pdp-plate.liquid).
   De prijs en voorraad in de rechterkolom staan verborgen maar worden door het thema nog steeds bijgewerkt
   bij het wisselen van variant; dit script neemt die tekst en status over, zodat het vlak altijd klopt. */
(function () {
  'use strict';
  var plate = document.querySelector('[data-lc-plate]');
  if (!plate) return;
  var scope = plate.closest('product-info') || document;
  var now = plate.querySelector('[data-lc-plate-now]');
  var was = plate.querySelector('[data-lc-plate-was]');
  var nowLabel = plate.querySelector('[data-lc-plate-now-label]');
  var wasLabel = plate.querySelector('[data-lc-plate-was-label]');
  var stockText = plate.querySelector('[data-lc-plate-stock-text]');
  var sectionId = scope.dataset && (scope.dataset.originalSection || scope.dataset.section);
  var inventory = scope.querySelector('.product-details product-inventory');
  var readVariant = function () {
    var data = scope.querySelector('variant-selects [data-selected-variant]');
    if (!data) return undefined;
    try { return JSON.parse(data.textContent); } catch (e) { return undefined; }
  };
  var inventoryVariant = readVariant();
  var sync = function () {
    var price = scope.querySelector('.product-details product-price');
    if (price && now) {
      var cur = price.querySelector('.price-item--last') || price.querySelector('.price-item--sale') || price.querySelector('.price-item');
      var old = price.querySelector('s, .price-item--regular:not(.price-item--last)');
      var curText = cur ? cur.textContent.replace(/\s+/g, ' ').trim() : '';
      var oldText = old ? old.textContent.replace(/\s+/g, ' ').trim() : '';
      if (curText && now.textContent !== curText) now.textContent = curText;
      if (was) {
        was.hidden = !oldText || oldText === curText;
        if (oldText && was.textContent !== oldText) was.textContent = oldText;
      }
      var onSale = was && !was.hidden;
      if (wasLabel) wasLabel.hidden = !onSale;
      if (nowLabel) {
        var label = onSale ? nowLabel.dataset.saleLabel : nowLabel.dataset.regularLabel;
        if (label && nowLabel.textContent !== label) nowLabel.textContent = label;
      }
    }
    var inv = inventory;
    if (inv && stockText) {
      var text = inv.querySelector('.product-inventory__text');
      var icon = inv.querySelector('.product-inventory__icon');
      var cls = icon ? icon.className : '';
      var status = /icon-pre_order/.test(cls) ? 'pre_order' : /icon-low/.test(cls) ? 'low' : /out_of_stock/.test(cls) ? 'out_of_stock' : 'in_stock';
      var value = text ? text.textContent.replace(/\s+/g, ' ').trim() : '';
      var variant = readVariant();
      if (variant === undefined) variant = inventoryVariant;
      if (variant === null || (variant && !variant.available)) status = 'out_of_stock';
      else if (variant && variant.available && status === 'out_of_stock') status = 'in_stock';
      if (variant === null && window.variantStrings) value = window.variantStrings.unavailable || value;
      if (value && stockText.textContent.trim() !== value) stockText.textContent = value;
      if (!plate.classList.contains('lc-plate--' + status)) {
        plate.classList.remove('lc-plate--low', 'lc-plate--out_of_stock', 'lc-plate--in_stock', 'lc-plate--pre_order');
        plate.classList.add('lc-plate--' + status);
      }
    }
  };
  sync();
  if (sectionId && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || data.sectionId !== sectionId || !data.html) return;
      // product-info refreshes only the inventory text; its old icon class stays behind.
      // The freshly rendered inventory also retains the correct low-stock/pre-order state.
      var text = data.html.getElementById('Inventory-' + sectionId);
      var fresh = text && text.closest('product-inventory');
      if (fresh) inventory = fresh;
      inventoryVariant = data.variant;
      sync();
    });
  }
  var details = scope.querySelector('.product-details');
  if (details && window.MutationObserver) {
    var queued = 0;
    new MutationObserver(function () {
      if (queued) return;
      queued = window.requestAnimationFrame(function () { queued = 0; sync(); });
    }).observe(details, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
})();

